// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prepare-olymp-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Verdana, Geneva, sans-serif;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.page-header h2 {
  margin: 0 0 10px 0;
  font-size: 2.2em;
  font-weight: 600;
}

.page-description {
  margin: 0;
  font-size: 1.1em;
  opacity: 0.9;
  line-height: 1.5;
}

.upload-section {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.file-input-group {
  margin-bottom: 20px;
}

.file-input-group label {
  display: block;
  margin-bottom: 10px;
}

.label-text {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-size: 1.1em;
}

.file-input-group input[type="file"] {
  width: 100%;
  padding: 12px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1em;
}

.file-input-group input[type="file"]:hover {
  border-color: #667eea;
  background: #f0f4ff;
}

.file-input-group input[type="file"]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.file-info {
  margin-top: 10px;
  padding: 10px;
  background: #e8f5e8;
  border-radius: 6px;
  border-left: 4px solid #4caf50;
}

.file-name {
  font-weight: 600;
  color: #2e7d32;
}

.file-size {
  color: #666;
  font-size: 0.9em;
  margin-left: 10px;
}

.validation-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  margin: 15px 0;
}

.validation-success {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
  padding: 20px;
  margin: 15px 0;
}

.validation-success h4 {
  color: #155724;
  margin: 0 0 15px 0;
  font-size: 1.2em;
}

.validation-details p {
  margin: 8px 0;
  color: #155724;
}

.preview-section {
  margin-top: 20px;
}

.preview-section h5 {
  color: #155724;
  margin: 15px 0 10px 0;
}

.preview-table-container {
  max-height: 300px;
  overflow: auto;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
}

.preview-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9em;
}

.preview-table th,
.preview-table td {
  padding: 8px 12px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.preview-table th {
  background: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}

.preview-table td {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.validation-error {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
  padding: 20px;
  margin: 15px 0;
}

.validation-error h4 {
  color: #721c24;
  margin: 0 0 15px 0;
  font-size: 1.2em;
}

.validation-error p {
  color: #721c24;
  margin: 8px 0;
}

.required-columns {
  margin-top: 15px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
}

.button-group {
  margin: 25px 0;
  text-align: center;
}

.process-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 8px;
  font-size: 1.1em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 250px;
  justify-content: center;
}

.process-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.process-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.message {
  padding: 15px;
  border-radius: 6px;
  margin: 15px 0;
  font-weight: 500;
  text-align: center;
}

.message.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.message.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.message.info {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.format-info {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.format-info h3 {
  color: #333;
  margin: 0 0 20px 0;
  font-size: 1.4em;
  border-bottom: 2px solid #667eea;
  padding-bottom: 10px;
}

.format-details {
  margin-bottom: 30px;
}

.format-details p {
  margin: 10px 0;
  color: #555;
  line-height: 1.6;
}

.format-details ul {
  margin: 15px 0;
  padding-left: 20px;
}

.format-details li {
  margin: 8px 0;
  color: #555;
  line-height: 1.5;
}

.format-details li strong {
  color: #333;
}

.note {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  padding: 15px;
  margin: 20px 0;
  border-left: 4px solid #ffc107;
}

.note strong {
  color: #856404;
}

/* Responsive design */
@media (max-width: 768px) {
  .prepare-olymp-container {
    padding: 15px;
  }
  
  .page-header {
    padding: 15px;
  }
  
  .page-header h2 {
    font-size: 1.8em;
  }
  
  .upload-section,
  .format-info {
    padding: 20px;
  }
  
  .process-button {
    min-width: 200px;
    padding: 12px 25px;
  }
  
  .preview-table-container {
    font-size: 0.8em;
  }
  
  .preview-table th,
  .preview-table td {
    padding: 6px 8px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/PrepareOlymp.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":[".prepare-olymp-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: Verdana, Geneva, sans-serif;\n}\n\n.page-header {\n  text-align: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.page-header h2 {\n  margin: 0 0 10px 0;\n  font-size: 2.2em;\n  font-weight: 600;\n}\n\n.page-description {\n  margin: 0;\n  font-size: 1.1em;\n  opacity: 0.9;\n  line-height: 1.5;\n}\n\n.upload-section {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n}\n\n.file-input-group {\n  margin-bottom: 20px;\n}\n\n.file-input-group label {\n  display: block;\n  margin-bottom: 10px;\n}\n\n.label-text {\n  display: block;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n  font-size: 1.1em;\n}\n\n.file-input-group input[type=\"file\"] {\n  width: 100%;\n  padding: 12px;\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  background: #fafafa;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1em;\n}\n\n.file-input-group input[type=\"file\"]:hover {\n  border-color: #667eea;\n  background: #f0f4ff;\n}\n\n.file-input-group input[type=\"file\"]:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.file-info {\n  margin-top: 10px;\n  padding: 10px;\n  background: #e8f5e8;\n  border-radius: 6px;\n  border-left: 4px solid #4caf50;\n}\n\n.file-name {\n  font-weight: 600;\n  color: #2e7d32;\n}\n\n.file-size {\n  color: #666;\n  font-size: 0.9em;\n  margin-left: 10px;\n}\n\n.validation-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px;\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n  margin: 15px 0;\n}\n\n.validation-success {\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  border-radius: 6px;\n  padding: 20px;\n  margin: 15px 0;\n}\n\n.validation-success h4 {\n  color: #155724;\n  margin: 0 0 15px 0;\n  font-size: 1.2em;\n}\n\n.validation-details p {\n  margin: 8px 0;\n  color: #155724;\n}\n\n.preview-section {\n  margin-top: 20px;\n}\n\n.preview-section h5 {\n  color: #155724;\n  margin: 15px 0 10px 0;\n}\n\n.preview-table-container {\n  max-height: 300px;\n  overflow: auto;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n}\n\n.preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9em;\n}\n\n.preview-table th,\n.preview-table td {\n  padding: 8px 12px;\n  text-align: left;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.preview-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.preview-table td {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.validation-error {\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 6px;\n  padding: 20px;\n  margin: 15px 0;\n}\n\n.validation-error h4 {\n  color: #721c24;\n  margin: 0 0 15px 0;\n  font-size: 1.2em;\n}\n\n.validation-error p {\n  color: #721c24;\n  margin: 8px 0;\n}\n\n.required-columns {\n  margin-top: 15px;\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 4px;\n}\n\n.button-group {\n  margin: 25px 0;\n  text-align: center;\n}\n\n.process-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 15px 30px;\n  border-radius: 8px;\n  font-size: 1.1em;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 250px;\n  justify-content: center;\n}\n\n.process-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.process-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.message {\n  padding: 15px;\n  border-radius: 6px;\n  margin: 15px 0;\n  font-weight: 500;\n  text-align: center;\n}\n\n.message.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.message.error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.message.info {\n  background: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n}\n\n.format-info {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.format-info h3 {\n  color: #333;\n  margin: 0 0 20px 0;\n  font-size: 1.4em;\n  border-bottom: 2px solid #667eea;\n  padding-bottom: 10px;\n}\n\n.format-details {\n  margin-bottom: 30px;\n}\n\n.format-details p {\n  margin: 10px 0;\n  color: #555;\n  line-height: 1.6;\n}\n\n.format-details ul {\n  margin: 15px 0;\n  padding-left: 20px;\n}\n\n.format-details li {\n  margin: 8px 0;\n  color: #555;\n  line-height: 1.5;\n}\n\n.format-details li strong {\n  color: #333;\n}\n\n.note {\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n  padding: 15px;\n  margin: 20px 0;\n  border-left: 4px solid #ffc107;\n}\n\n.note strong {\n  color: #856404;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .prepare-olymp-container {\n    padding: 15px;\n  }\n  \n  .page-header {\n    padding: 15px;\n  }\n  \n  .page-header h2 {\n    font-size: 1.8em;\n  }\n  \n  .upload-section,\n  .format-info {\n    padding: 20px;\n  }\n  \n  .process-button {\n    min-width: 200px;\n    padding: 12px 25px;\n  }\n  \n  .preview-table-container {\n    font-size: 0.8em;\n  }\n  \n  .preview-table th,\n  .preview-table td {\n    padding: 6px 8px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
